<template>
    <div class="root-page">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Page',
}
</script>

<style lang="scss" scoped>
.root-page {
    height: 100vh;
    background: white;
    overflow-y: auto;
    
}
</style>